// @ts-nocheck

import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import useDLocalBoletoAndPixPaymentHandler from 'publisher/hooks/payment/useDLocalBoletoAndPixPaymentHandler'
import React from 'react'
import FieldErrors from '../../FieldErrors'
import BaseButton from '../BaseButton'

function DLocalBoletoAndPixPaymentButton({
  entity,
}: {
  entity: OldEntityInterface
}) {
  const { styles, mobileStyles, options, mobileOptions } = entity
  const { errors, isLoading, handleSubmit } =
    useDLocalBoletoAndPixPaymentHandler(entity)

  return (
    <>
      <BaseButton
        handleClick={handleSubmit}
        disabled={isLoading}
        styles={styles}
        mobileStyles={mobileStyles}
        attrId={options.attrId}
        text={options.text}
        borderType={options.borderType}
        mobileBorderType={mobileOptions.borderType}
        appearance={options.appearance}
        loading={isLoading}
        loadingText={options.loadingText}
        subText={options.subText}
        subTextColor={options.subTextColor}
        subTextFontSize={options.subTextFontSize}
        subTextFontFamily={options.subTextFontFamily}
        mobileSubTextColor={mobileOptions.subTextColor}
        mobileSubTextFontSize={mobileOptions.subTextFontSize}
        mobileSubTextFontFamily={mobileOptions.subTextFontFamily}
        iconClassNameBefore={options.iconClassNameBefore}
        iconClassNameAfter={options.iconClassNameAfter}
        hoverStyles={options?.hover}
        hoverMobileStyles={mobileOptions?.hover}
      />
      <FieldErrors errors={errors} align="center" />
    </>
  )
}

export default DLocalBoletoAndPixPaymentButton
